export default "__VITE_ASSET__TpTqmWBi__"